import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import HowItWorksSection from './components/HowItWorksSection';
import MarketAuthoritySection from './components/MarketAuthoritySection';
import PricingSection from './components/PricingSection';
import VehicleSegmentsSection from './components/VehicleSegmentsSection';
import TrustSection from './components/TrustSection';

const siteUrl = (import.meta.env.VITE_SITE_URL as string | undefined) ?? 'https://automatchlab.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: `${siteUrl}/`,
      name: 'Automatchlab',
      description:
        'AI-powered vehicle intelligence combined with expert guidance to help you identify the best makes and models for your needs.',
      publisher: { '@id': `${siteUrl}/#organization` },
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'Automatchlab',
      url: `${siteUrl}/`,
      description:
        'Automatchlab is a vehicle matchmaking platform that combines AI-powered market intelligence with expert human analysis to help car buyers find the perfect vehicle.',
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: `${siteUrl}/`,
      name: 'Automatchlab - Vehicle Intelligence for Smarter Buying',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      description:
        'Get independent vehicle recommendations in one consultation. Our platform scans every available option across all makes, models, and price points combined with expert human analysis.',
    },
    {
      '@type': 'Service',
      '@id': `${siteUrl}/#service`,
      name: 'Vehicle Matchmaking & Intelligence',
      provider: { '@id': `${siteUrl}/#organization` },
      description:
        'AI-powered vehicle analysis and expert consulting service that matches buyers with the perfect vehicle across all makes, models, and price points.',
      url: `${siteUrl}/services`,
      serviceType: 'Vehicle Consulting',
      areaServed: 'Canada',
    },
  ],
};

export default function HomePage() {
  return (
    <>
      <title>Automatchlab - Vehicle Intelligence for Smarter Buying</title>
      <meta
        name="description"
        content="AI-powered vehicle intelligence combined with expert guidance to help you identify the best makes and models for your needs. Get independent vehicle recommendations in one consultation."
      />
      <link rel="canonical" href={`${siteUrl}/`} />
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
      <div className="min-h-screen" style={{ background: '#0e0b07' }}>
        <HeroSection />
        <ProblemSection />
        <HowItWorksSection />
        <MarketAuthoritySection />
        <div className="mt-12 sm:mt-20">
          <VehicleSegmentsSection />
        </div>
        <PricingSection />
        <TrustSection />
      </div>
    </>
  );
}
